import React from 'react';
import { RegistrationSummaryMessage } from '../../../domain/richMessage.interface';

interface RegistrationCardProps {
  data: RegistrationSummaryMessage;
}

export const RegistrationCard: React.FC<RegistrationCardProps> = ({ data }) => (
  <div className="bg-white rounded-2xl border border-black/[0.08] shadow-sm overflow-hidden">
    <div className="bg-coral px-4 py-3">
      <p className="text-white font-bold text-xs uppercase tracking-widest">
        GIVEAWAY ENTRY CONFIRMED
      </p>
    </div>
    <div className="divide-y divide-grey-91">
      <div className="flex items-center justify-between px-4 py-3">
        <span className="text-navy-64 text-sm">Entry number</span>
        <span className="text-navy font-bold text-sm">{data.entry_number}</span>
      </div>
      <div className="flex items-center justify-between px-4 py-3">
        <span className="text-navy-64 text-sm">Registered email</span>
        <span className="text-navy font-bold text-sm text-right break-all">{data.email}</span>
      </div>
      <div className="flex items-center justify-between px-4 py-3">
        <span className="text-navy-64 text-sm">Drawing date</span>
        <span className="text-navy font-bold text-sm">{data.raffle_date}</span>
      </div>
    </div>
    <div className="px-4 py-3 border-t border-grey-91">
      <p className="text-navy text-sm leading-relaxed">{data.message}</p>
    </div>
  </div>
);
